/* DOMNO. portal — cross-cutting UI corrections that belong to no single screen.

   1. "Return an item" was small grey text sitting under real buttons, so it did not read as
      pressable (Dom flagged the same fault for "View all orders"). Both are the drawer's `.link`
      class, so promoting that class fixes both, and the returns one is retitled **Start a return**
      — what happens, not what it is about.

   2. ⚠ THE RETURN CARRIES THE ORDER WITH IT. Dom, 9 Sep: "if they can start a return now, let
      them then automatically have that order and the email used for that order in the returns
      text field. That's all that was for."
      The link now opens returns.domno.com with `?order=` and `?identity=` taken from the card it
      sits in and the signed-in customer, and the returns worker fills both fields and submits
      itself. A customer who arrives from their own account never retypes an order number.

      This is a CONVENIENCE ONLY. `/api/lookup` on the returns side still verifies the order and
      the identity exactly as it does for a typed-in return, so a shared or guessed link proves
      nothing it did not prove before. The returns page also strips the query string from the
      address bar afterwards so an order number is not left in history or a share sheet.

   3. Loads the preview pages on request (10 Sep 2026). They live in their own files so the design
      can be argued about without touching a byte a customer runs, and so iterating on them never
      means rewriting the 32KB orders file. The asset URL is lifted off this very script's own src,
      because JS has no asset_url and the Liquid loader is not worth editing for a preview flag.

        ?dp=ordermock      every state of the order screen, side by side
        ?dp=portalpreview  the whole portal as a made-up customer with three orders

   ⚠ querySelectorAll, not getElementById. The harness page renders a second element carrying the
   same id and getElementById returns only the first, so the fix silently skipped the one being
   looked at. Duplicate ids are a fact of life here.

   ⚠ IDEMPOTENT. The drawer swaps panels rather than reloading, so this runs on an interval and
   every pass checks a stamp before touching anything. */
(function(){
  var RETURNS = 'https://returns.domno.com/';

  function customerEmail(){
    try{ return (window.DP_CUSTOMER && window.DP_CUSTOMER.email) || ''; }catch(e){ return ''; }
  }

  /* the order name lives in the card the link sits inside — `.n` is the drawer's own class */
  function orderNear(el){
    try{
      var card = el.closest ? el.closest('.card') : null;
      var n = card && card.querySelector('.n');
      return n ? n.textContent.trim().replace(/^#/, '') : '';
    }catch(e){ return ''; }
  }

  function returnsUrl(order){
    var q = [];
    if (order) q.push('order=' + encodeURIComponent(order));
    var em = customerEmail();
    if (em) q.push('identity=' + encodeURIComponent(em));
    return RETURNS + (q.length ? '?' + q.join('&') : '');
  }

  /* ---- 3. the preview pages, on request only ---- */
  var PREVIEWS = {
    ordermock:     'domno-portal-ordermock.js',
    portalpreview: 'domno-portal-preview.js'
  };
  function loadPreview(){
    try{
      var dp = new URLSearchParams(location.search).get('dp');
      var file = PREVIEWS[dp];
      if (!file) return;
      if (document.getElementById('dp-preview-js')) return;
      var me = document.querySelector('script[src*="domno-portal-ui"]');
      if (!me) return;
      var sc = document.createElement('script');
      sc.id = 'dp-preview-js';
      sc.src = me.src.split('?')[0].replace('domno-portal-ui.js', file);
      document.head.appendChild(sc);
    }catch(e){}
  }
  loadPreview();

  /* ---- 4. 🔴 THE REVIEW ROW COMES OUT OF "OTHER WAYS TO EARN" (14 Sep 2026) ----
     Charlie: "remove the review option from other ways to earn, we're keeping that as a loox £10
     per item flow away from the portal."
     Reviews stopped granting a free piece this morning, so a row reading "Leave a review / Free
     item on your next order" sitting under Refer a mate was the last place in the portal still
     promising one.

     Removed from here rather than from the drawer because snippets/domno-portal-drawer.liquid is
     30KB of Charlie's own markup, and every module in this portal exists precisely so that file
     never has to be rewritten for a one-line change.

     ⚠ Matched on the row's OWN TEXT, never on position. The birthday row sits beside it, the two
     have swapped order before, and Liquid renders one of two birthday variants depending on
     whether a date is saved — so an index would break the first time anything moved. */
  function dropReviewRow(){
    var rows = document.querySelectorAll('#p-rewards .rw');
    for (var i=0;i<rows.length;i++){
      var r = rows[i];
      if (r.getAttribute('data-dp-rv') === '1') continue;
      r.setAttribute('data-dp-rv','1');
      var n = r.querySelector('.n');
      if (n && /^\s*leave a review\s*$/i.test(n.textContent || '')){
        if (r.parentNode) r.parentNode.removeChild(r);
      }
    }
  }

  /* ---- 5. 🔴 "GET IT FOR FREE" IS NOW A BUTTON (15 Sep 2026) ----
     Charlie: "on the rewards saved, when it says you can get this ring for free you should tap on
     it and then it gets added to the cart as if it was the free ring."

     The tag was decoration sitting inside the card's own <a>, so tapping it did the one thing it
     must not: navigated to the product page and threw the drawer away.

     ⚠ IT OPENS THE PICKER ON THAT PIECE RATHER THAN ADDING BLIND. A ring has a size and most
     pieces have a colour, so there is no honest way to put one in the bag without asking. The tap
     lands them on that piece's own size/colour step and the existing claim flow adds it at £0
     from there — the same number of taps as the picker, minus hunting for it in a grid of 50.

     ⚠ MATCHED BY TITLE, AND THAT IS THE WEAK LINK. The picker's dataset
     (snippets/domno-portal-ladderdata.liquid) carries title, price, images, options and variants
     — and NO handle. The saved list is keyed by handle. Title is the only thing the two share,
     and domno-portal-claim.js already documents a bug from exactly this: two active products in
     Rings once shared a title. So ONE exact match opens that piece; zero or two or more opens the
     picker and lets them choose. Never guess between two.

     ⚠ SIGNED OUT, THE TAP IS LEFT ALONE. freeState() returns can:true for signed-out visitors, so
     the tag renders for them too — but dpOpenPicker and #dp-rings only exist behind `if customer`.
     The picker check therefore happens BEFORE preventDefault, so a signed-out tap still follows
     the link to the product page. Swallowing it would be worse than the original behaviour.

     ⚠ THIS FILE, NOT domno-saved.js. That file is 50KB and a theme push rewrites all of it. The
     tag is rendered there; the behaviour belongs where it is cheapest to change, and this file
     exists for exactly these cross-cutting corrections. */
  function pickerRows(){
    try{
      var h = document.getElementById('dp-rings');
      return h ? (JSON.parse(h.getAttribute('data-rings') || '[]') || []) : [];
    }catch(e){ return []; }
  }

  function indexByTitle(title){
    var want = String(title || '').trim().toLowerCase();
    if (!want) return -1;
    var rows = pickerRows(), hit = -1;
    for (var i=0;i<rows.length;i++){
      var t = String((rows[i] && rows[i][0]) || '').trim().toLowerCase();
      if (t === want){
        if (hit > -1) return -1;            /* same title twice — refuse to guess */
        hit = i;
      }
    }
    return hit;
  }

  function freeTagTap(e){
    var tag = e.target && e.target.closest ? e.target.closest('.sv-tag') : null;
    if (!tag) return;
    var card = tag.closest('.sv-prod');
    if (!card) return;
    if (typeof window.dpOpenPicker !== 'function') return;   /* signed out: let the link work */

    e.preventDefault();
    e.stopPropagation();

    var nameEl = card.querySelector('.sv-name');
    var title = nameEl ? nameEl.textContent : '';

    /* domno-portal-ladder.js wraps dpOpenPicker to repoint the dataset at the customer's current
       rung, so the rows are only correct AFTER it has opened — reading them first gets the last
       rung's grid. */
    try{ window.dpOpenPicker(); }catch(err){ return; }
    setTimeout(function(){
      var idx = indexByTitle(title);
      if (idx > -1 && typeof window.dpSel === 'function'){
        try{ window.dpSel(idx); }catch(err){}
      }
    }, 80);
  }
  document.addEventListener('click', freeTagTap, true);

  /* it is a button now, so it has to look and behave like one */
  function tagsTappable(){
    var tags = document.querySelectorAll('.sv-tag');
    for (var i=0;i<tags.length;i++){
      var t = tags[i];
      if (t.getAttribute('data-dp-tap') === '1') continue;
      t.setAttribute('data-dp-tap','1');
      if (typeof window.dpOpenPicker !== 'function') continue;
      t.setAttribute('role','button');
      t.setAttribute('tabindex','0');
      t.style.cursor = 'pointer';
      t.style.textDecoration = 'underline';
    }
  }

  function fix(){
    dropReviewRow();
    tagsTappable();
    var links = document.querySelectorAll('#domno-portal .link');
    for (var i=0;i<links.length;i++){
      var el = links[i];
      if (el.getAttribute('data-dp-ui') === '1') continue;
      var txt = (el.textContent || '').trim().toLowerCase();

      if (txt.indexOf('return') > -1){
        el.textContent = 'Start a return';
        el.classList.add('dp-linkbtn');
        (function(el){
          var url = returnsUrl(orderNear(el));
          el.onclick = function(e){
            if (e){ e.preventDefault(); e.stopPropagation(); }
            window.location.href = url;
          };
        })(el);
      } else if (txt.indexOf('view all orders') > -1){
        el.classList.add('dp-linkbtn');
      }
      el.setAttribute('data-dp-ui','1');
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();

  var n = 0, iv = setInterval(function(){ n++; fix(); if (n > 400) clearInterval(iv); }, 400);
  document.addEventListener('click', function(){ setTimeout(fix, 60); }, true);

  window.dpReturnsUrl = returnsUrl;   /* so other modules can link the same way */
})();